/**
 * Is this page shown inside another page — the rave admin's wizard preview
 * (step 64, `WizardPreview.tsx`)? A framed app is an admin LOOKING at the
 * rave, not a raver using it: it records no statistics and downloads nothing
 * for offline (2026-10-10). Reading `window.top` from a cross-origin frame
 * throws in some browsers; that also means framed.
 */
export function isFramed(): boolean {
  try {
    return typeof window !== 'undefined' && window.self !== window.top;
  } catch {
    return true;
  }
}

/**
 * The refusal a framed app gets for any write (`lib/api.ts`, round 7 point 51:
 * the wizard's preview is read-only). Not a verdict on the change itself — a
 * sync never sets a batch aside for it.
 */
export const PREVIEW_READ_ONLY = 'preview_read_only';
